/*
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-05-31 11:37:41
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2024-12-17 15:02:47
 * @FilePath: /lobby/src/stores/envelope.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { url } from '@/common/config'
import { setLocalStorage } from '@/common/localStorage'
import { post } from '@/common/request'
import { useUserStore } from '@/stores/user.js'
import dayjs from 'dayjs'
import { defineStore } from 'pinia'

export const useEnvelopeStore = defineStore('redpackage', {
  state: () => {
    return {
      reward: null,
      envelopeId: 0,
      inviteUserId: 0,
      inviteUserName: 0,
      isFinishGuide: false,
      noticeRecords: []
    }
  },
  getters: {
    country() {
      return useUserStore().country
    }
    // inviteUserId() {
    //   if (getLocalStorage('invite') && getLocalStorage('invite') != '') {
    //     return getLocalStorage('invite').split('|')[1]
    //   }
    //   return ''
    // }
  },
  actions: {
    updateInvite({ envelopeId, inviteUserId, inviteUserName }) {
      this.envelopeId = envelopeId
      this.inviteUserId = inviteUserId
      this.inviteUserName = inviteUserName
      setLocalStorage('invite', envelopeId + '|' + inviteUserId + '|' + inviteUserName)
    },
    updateReward(reward) {
      this.reward = reward
    },
    claimed() {
      return post(url.redpackage.claimed).then((r) => {
        this.noticeRecords = r.records
        return r
      })
    },
    claim(envelopeId) {
      return post(url.redpackage.claim, {
        envelopeId,
        browserId: (window.visitorId || dayjs().unix()).toString()
      })
    },
    collected(envelopeId) {
      return post(url.redpackage.collected, { envelopeId })
    },
    create() {
      return post(url.redpackage.create, {
        browserId: window.visitorId || dayjs().unix().toString()
      })
    },
    envelope() {
      return post(url.redpackage.envelope)
    },
    share(envelopeId) {
      return post(url.redpackage.share, { envelopeId })
    },
    domain() {
      return post(url.redpackage.domain)
    },
    guide() {
      return post(url.redpackage.guide).then((r) => {
        this.isFinishGuide = r.guide
        return r
      })
    },
    finishGuide() {
      return post(url.redpackage.finishGuide)
    },
    latestCollected(envelopeId) {
      return post(url.redpackage.latestCollected, { envelopeId })
    },
    /**
     * 获取展示红包领取奖励额度
     * @returns
     */
    displayReward() {
      return post(url.redpackage.displayReward, { country: this.country })
    },
    /**
     * 获取已领取红包奖励总额
     * @returns
     */
    totalClaimedReward() {
      return post(url.redpackage.totalClaimedReward, { country: this.country })
    }
  }
})
